export default {
  namespaced: true,

  state: {
    savedFilters: JSON.parse(localStorage.getItem('familiesFilters')??null) || null,
    familiesTranscationsFilters: JSON.parse(localStorage.getItem('familiesTranscationsFilters')??null) || null,
  },

  mutations: {
    SET_FILTERS(state, filters) {
      state.savedFilters = filters;
      localStorage.setItem('familiesFilters', JSON.stringify(filters));
    },

    CLEAR_FILTERS(state) {
      state.savedFilters = null;
      localStorage.removeItem('familiesFilters');

    },
    SET_FAMILIES_TRANSACTIONS_FILTERS(state, filters) {
      state.familiesTranscationsFilters = filters;
      localStorage.setItem('familiesTranscationsFilters', JSON.stringify(filters));
    },
    
    CLEAR_FAMILIES_TRANSACTIONS_FILTERS(state) {
      state.familiesTranscationsFilters = null;
      localStorage.removeItem('familiesTranscationsFilters');
    },
  },
  getters: {
    getFilters: state => state.savedFilters,
    getFamiliesTransactionsFilters: state => state.familiesTranscationsFilters
  }
};